import styled from 'styled-components';

import contentTop from '../../assets/images/contentTop.svg';

export const AppContainer = styled.div`
	max-height: 100%;

	display: flex;
	flex-direction: column;
	align-items: stretch;

	position: relative;
	z-index: 0;
	top: 0;
	left: 0;
`;

export const PreContentBox = styled.div`
	height: 56px;
	background-image: url("${contentTop}");
	background-size: contain;
	background-position: center;
	background-repeat: repeat-x;

	position: relative;
	top: -20px;
	z-index: 1;

	@media (max-width: 1102px) {
		background-size: cover;
	}
`;

export const ContentContainer = styled.div<{ $path: string; $navHeight: number }>`

	width: 100%; 
	min-height: 72vh;
	margin: 0 auto; 
	padding: 20px 0 214px 0;
	box-sizing: border-box; 
	display: flex; 
	flex-direction: column;
	align-items: center; 

	${({ $path: path }) => path === '/calendari' && 'max-width: 100%;'}
`;
